// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseBoolean = (value: any, strict = false): boolean => {
  if (value === 'true') return true
  if (value === 'false') return false

  if (strict) undefined || new Boolean(value).valueOf()
}
